import lensesFromSchema from 'root/src/shared/util/lensesFromSchema'

import { variableSchemaKey } from 'root/src/shared/constants/keys'

const embeddedModuleLenses = {
	type: 'object',
	properties: {
		embedded: {
			type: 'object',
			patternProperties: {
				[variableSchemaKey]: {
					type: 'object',
					properties: {
						fixedFilter: 'array',
						fieldData: {
							type: 'array',
							items: {
								type: 'object',
								properties: {},
							},
						},
					},
				},
			},
		},
	},
}

export const embeddedDescriptionLenses = lensesFromSchema(
	embeddedModuleLenses,
)

export const embeddedStoreLenses = lensesFromSchema(
	embeddedModuleLenses,
)
